import { faFilePdf } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { CalendarEvent } from "../../../models/CalendarEvent";
import { Delivery } from "../../../models/Delivery";
import TeamInfo from "../../../teamInfo";
import { DamnMapItems } from "../Map/useDamnMapItems";
import DamnPdfExportDialog from "./damnPdfExportDialog";

interface Props {
    delivery: Delivery;
    calendarEvent: CalendarEvent;
    mapItems: DamnMapItems;
    gcTeam: TeamInfo | null;
    receivingTeam: TeamInfo | null;
}

const DamnPdfExportButton: React.FC<Props> = (props) => {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                className="p-2.5 cursor-pointer hover:bg-plot-orange/10 rounded-xl transition-all duration-200 hover:scale-105"
                aria-label="Printable PDF"
                title="Printable PDF"
            >
                <FontAwesomeIcon icon={faFilePdf} className="text-gray-700 hover:text-plot-orange" />
            </button>
            {open && <DamnPdfExportDialog onClose={() => setOpen(false)} {...props} />}
        </>
    );
};

export default DamnPdfExportButton;
